import AuthService from '@forwardflow/services/AuthService'
import { Button } from '@forwardflow/ui'
import Icon from '@forwardflow/ui/Icons'
import { useState, useEffect, useCallback } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { assistantAuthPath, signupVerificationUrl } from '@forwardflow/services/AssistantConnect'

const VerifyEmailComponent = () => {
   const [searchParams] = useSearchParams()
   const [verificationEmailSent, setVerificationEmailSent] = useState(false)
   const [cooldown, setCooldown] = useState(0)
   const [resendError, setResendError] = useState('')

   useEffect(() => {
      if (cooldown <= 0) return
      const timer = setInterval(() => {
         setCooldown((prev) => prev - 1)
      }, 1000)
      return () => clearInterval(timer)
   }, [cooldown])

   const handleResendEmail = useCallback(async () => {
      if (cooldown > 0) return
      try {
         setResendError('')
         const redirectUrl = signupVerificationUrl(window.location.origin, searchParams)
         const res = await AuthService.apiResendVerificationMail(redirectUrl)
         if (res?.success === false && res?.timeRemaining) {
            setCooldown(res.timeRemaining)
            setResendError(res.message || '')
         } else {
            setVerificationEmailSent(true)
            setCooldown(60)
         }
      } catch (error) {
         console.error('Error resending verification email:', error)
      }
   }, [cooldown, searchParams])

   return (
      <>
         <div className="flex min-h-screen px-4 lg:px-[30px] flex-col  items-center text-center pt-14 md:pt-28">
            <a href="/">
               <img
                  width={'165px'}
                  src="/images/fff-logo.png"
                  className="md:absolute left-10 top-10"
                  alt="ff icon"
               />
            </a>

            <Link
               className="bg-white/10 transition-all hover:bg-white/20 w-[200px] h-12 flexc rounded-full md:absolute mt-7 md:mt-0 top-10 right-4 md:right-16"
               to={assistantAuthPath('/signup', searchParams)}
            >
               Sign up
            </Link>
            <h1 className="text-[20px] md:text-[24px] mt-[30px] mb-7 font-medium">
               Level up your Real Estate game with Forward Flow
            </h1>
            <h2 className="text-[12px] md:text-[14px] mb-[54px] text-[#C9C9C9]">
               Sign in to your Forward Flow Account
            </h2>

            <div className="w-full max-w-[450px] mx-auto bg-black/40 border border-white/20 rounded-xl p-8 flex flex-col justify-center">
               <Icon name="Mail" className="mx-auto mb-5" />
               <h2 className="text-[20px] font-semibold mb-10">
                  Check your email
               </h2>
               <div className="text-[14px] leading-8">
                  <p className="text-white/70">We emailed a magic link to</p>
                  <p>{searchParams?.get('email')}</p>
                  <p className="mb-4 text-white/70">
                     Click the link to finish sign up
                  </p>
               </div>
               <Button
                  onClick={handleResendEmail}
                  isDisabled={cooldown > 0}
               >
                  {cooldown > 0
                     ? `Resend in ${cooldown}s`
                     : 'Resend verification mail'}
               </Button>
               {verificationEmailSent && cooldown > 0 && (
                  <p className="mt-3 text-green-500 text-[14px]">
                     Verification email sent successfully, please check mail
                  </p>
               )}
               {resendError && (
                  <p className="mt-3 text-yellow-500 text-[14px]">
                     {resendError}
                  </p>
               )}
            </div>
         </div>
      </>
   )
}

export default VerifyEmailComponent
